module.exports = __webpack_public_path__ + "img/pingcyun.bf6df404.jpg";